import { Component, Input, OnInit } from '@angular/core';
import { ThemeConstantService } from '../../services/theme-constant.service';
import { roleService } from 'src/app/services/role.service';
import { Router } from '@angular/router';
import { MenuItem } from '../../interfaces/menu-item';


// interface MenuItem {
//   title: string;
//   iconType?: 'nzIcon' | 'fontawesome';
//   icon?: string;
//   iconTheme?: string;
//   path?: string;
//   submenu: MenuItem[];
//   role: 'etudiant' | 'enseignant';
// }

@Component({
  selector: 'app-right-side-nav',
  templateUrl: './right-side-nav.component.html',
  styleUrls: ['./right-side-nav.component.css'],
})
export class RightSideNavComponent implements OnInit {
  @Input() isRightSideNavOpen: boolean = false;
  @Input() user: any;
  rtl = document.documentElement.dir === 'rtl'; // -arabic- pose par main.ts
  isSideNavDark: boolean;
  openSubmenus: { [key: string]: boolean } = {};

  menuItems: MenuItem[] = [
    // Etudiant menu
    {
      title: 'nav.myUniversity',
      iconType: 'nzIcon',
      icon: 'home',
      iconTheme: 'outline',
      submenu: [
        {
          title: 'nav.myContacts',
          role: 'etudiant', // Added role
          submenu: [
            {
              title: 'nav.studentReps',
              path: '#',
              submenu: [],
              role: 'etudiant',
            },
            {
              title: 'nav.studentServices',
              path: '#',
              submenu: [],
              role: 'etudiant',
            },
            {
              title: 'nav.faculties',
              path: '#',
              submenu: [],
              role: 'etudiant',
            },
            {
              title: 'nav.ufr',
              path: '#',
              submenu: [],
              role: 'etudiant',
            },
            {
              title: 'nav.doctoralSchools',
              path: '#',
              submenu: [],
              role: 'etudiant',
            },
            {
              title: 'nav.equalityNetwork',
              path: '#',
              submenu: [],
              role: 'etudiant',
            },
          ],
        },
        {
          title: 'nav.studyConditions',
          role: 'etudiant', // Added role
          submenu: [
            {
              title: 'nav.covid',
              path: '#',
              submenu: [],
              role: 'etudiant',
            },
            {
              title: 'nav.equality',
              path: '#',
              submenu: [],
              role: 'etudiant',
            },
            {
              title: 'nav.prevention',
              path: '#',
              submenu: [],
              role: 'etudiant',
            },
          ],
        },
        {
          title: 'nav.afterDegree',
          role: 'etudiant', // Added role
          submenu: [
            {
              title: 'nav.alumni',
              path: '#',
              submenu: [],
              role: 'etudiant',
            },
            {
              title: 'nav.continuingEd',
              path: '#',
              submenu: [],
              role: 'etudiant',
            },
            {
              title: 'nav.careerSupport',
              path: '#',
              submenu: [],
              role: 'etudiant',
            },
          ],
        },
        {
          title: 'nav.elections',
          role: 'etudiant', // Added role
          submenu: [
            {
              title: 'nav.atUniversity',
              path: '#',
              submenu: [],
              role: 'etudiant',
            },
            {
              title: 'nav.crous',
              path: '#',
              submenu: [],
              role: 'etudiant',
            },
          ],
        },
      ],
      role: 'etudiant',
    },
    {
      title: 'nav.mySchooling',
      iconType: 'nzIcon',
      icon: 'book',
      iconTheme: 'outline',
      submenu: [
        {
          title: 'nav.myStudies',
          role: 'etudiant', // Added role
          submenu: [
            {
              title: 'nav.calendar',
              path: '#',
              submenu: [],
              role: 'etudiant',
            },
            {
              title: 'nav.transversal',
              path: '#',
              submenu: [],
              role: 'etudiant',
            },
            {
              title: 'nav.certifications',
              path: '#',
              submenu: [],
              role: 'etudiant',
            },
            {
              title: 'nav.libraries',
              path: '#',
              submenu: [],
              role: 'etudiant',
            },
            {
              title: 'nav.abroad',
              path: '#',
              submenu: [],
              role: 'etudiant',
            },
            {
              title: 'nav.disability',
              path: '#',
              submenu: [],
              role: 'etudiant',
            },
            {
              title: 'nav.reorientation',
              path: '#',
              submenu: [],
              role: 'etudiant',
            },
            {
              title: 'nav.adjustStudies',
              path: '#',
              submenu: [],
              role: 'etudiant',
            },
          ],
        },
        {
          title: 'nav.myProcedures',
          role: 'etudiant', // Added role
          submenu: [
            {
              title: 'nav.reenroll',
              path: '#',
              submenu: [],
              role: 'etudiant',
            },
            {
              title: 'nav.cancelEnrollment',
              path: '#',
              submenu: [],
              role: 'etudiant',
            },
            {
              title: 'nav.transferFile',
              path: '#',
              submenu: [],
              role: 'etudiant',
            },
            {
              title:
                'nav.studentCard',
              path: '#',
              submenu: [],
              role: 'etudiant',
            },
            {
              title: 'nav.refund',
              path: '#',
              submenu: [],
              role: 'etudiant',
            },
            {
              title: 'nav.exemption',
              path: '#',
              submenu: [],
              role: 'etudiant',
            },
            {
              title: 'nav.changeContact',
              path: '#',
              submenu: [],
              role: 'etudiant',
            },
            {
              title: 'nav.changeName',
              path: '#',
              submenu: [],
              role: 'etudiant',
            },
            {
              title: 'nav.transcript',
              path: '#',
              submenu: [],
              role: 'etudiant',
            },
            {
              title: 'nav.diploma',
              path: '#',
              submenu: [],
              role: 'etudiant',
            },
          ],
        },
        {
          title: 'nav.proLife',
          role: 'etudiant', // Added role
          submenu: [
            {
              title: 'nav.internship',
              path: '#',
              submenu: [],
              role: 'etudiant',
            },
            { title: 'nav.workStudy', path: '#', submenu: [], role: 'etudiant' },
            {
              title: 'nav.entrepreneurship',
              path: '#',
              submenu: [],
              role: 'etudiant',
            },
            {
              title: 'nav.doctoralContract',
              path: '#',
              submenu: [],
              role: 'etudiant',
            },
            {
              title: 'nav.studentContract',
              path: '#',
              submenu: [],
              role: 'etudiant',
            },
            { title: 'nav.cifre', path: '#', submenu: [], role: 'etudiant' },
          ],
        },
        {
          title: 'nav.personalData',
          role: 'etudiant', // Added role
          submenu: [
            {
              title: 'nav.dataProcessing',
              path: '#',
              submenu: [],
              role: 'etudiant',
            },
          ],
        },
      ],
      role: 'etudiant',
    },
    {
      title: 'nav.studentLife',
      iconType: 'nzIcon',
      icon: 'team',
      iconTheme: 'outline',
      submenu: [],
      path: '#',
      role: 'etudiant',
    },
    {
      title: 'nav.toolbox',
      iconType: 'nzIcon',
      icon: 'tool',
      iconTheme: 'outline',
      submenu: [],
      path: '#',
      role: 'etudiant',
    },
    // Enseignant menu
    {
      title: 'nav.daily',
      iconType: 'nzIcon',
      icon: 'calendar',
      iconTheme: 'outline',
      submenu: [],
      path: '#',
      role: 'enseignant',
    },
    {
      title: 'nav.workLife',
      iconType: 'nzIcon',
      icon: 'desktop',
      iconTheme: 'outline',
      submenu: [],
      path: '#',
      role: 'enseignant',
    },
    {
      title: 'nav.careers',
      iconType: 'nzIcon',
      icon: 'rise',
      iconTheme: 'outline',
      submenu: [],
      path: '#',
      role: 'enseignant',
    },
    {
      title: 'nav.teachingSupport',
      iconType: 'nzIcon',
      icon: 'read',
      iconTheme: 'outline',
      submenu: [],
      path: '#',
      role: 'enseignant',
    },
    {
      title: 'nav.researchSupport',
      iconType: 'nzIcon',
      icon: 'experiment',
      iconTheme: 'outline',
      submenu: [],
      path: '#',
      role: 'enseignant',
    },
    {
      title: 'nav.organisation',
      iconType: 'nzIcon',
      icon: 'setting',
      iconTheme: 'outline',
      submenu: [],
      path: '#',
      role: 'enseignant',
    },
  ];
  get filteredMenuItems() {
    if (this.roleService.isEtudiants()||this.roleService.isEtudiant()) {
      return this.menuItems.filter((item) => item.role === 'etudiant');
    } else if (this.roleService.ENSEIGNANTS()||this.roleService.ENSEIGNANT()) {
      return this.menuItems.filter((item) => item.role === 'enseignant');
    }
    return [];
  }
  constructor(
    private themeService: ThemeConstantService,
    public roleService: roleService,
    private router: Router
  ) {
    this.themeService.isSideNavDarkChanges.subscribe(
      (isSideNavDark) => (this.isSideNavDark = isSideNavDark)
    );
  }

  toggleSubmenu(key: string) {
    this.openSubmenus[key] = !this.openSubmenus[key];
  }

  navigate(item: any) {
    if (item.path && item.path !== '#') {
      this.router.navigate([item.path]);
    }
    // Submenu items will toggle open/close automatically via ant-menu-submenu-open
  }

  ngOnInit(): void {}
}